/** Idle / movement rules for the HUD Unstuck affordance. */

export const UNSTUCK_IDLE_MS = 10_000;
/** Any position drift at or above this clears Unstuck immediately. */
export const UNSTUCK_MOVE_EPS_PX = 0.25;
/** Moving with intent — velocity above this clears Unstuck even if clamped in place. */
export const UNSTUCK_VEL_EPS_PX = 10;

export type UnstuckMotionInput = {
  px: number;
  py: number;
  sampleX: number;
  sampleY: number;
  lastMovementAtMs: number;
  velX: number;
  velY: number;
  nowMs: number;
  canOffer: boolean;
  /** Walk target, steer drag, or any movement intent — hide Unstuck immediately. */
  intentMoving?: boolean;
};

export type UnstuckMotionResult = {
  show: boolean;
  sampleX: number;
  sampleY: number;
  lastMovementAtMs: number;
};

export function isPlayerMovingForUnstuck(
  px: number,
  py: number,
  sampleX: number,
  sampleY: number,
  velX: number,
  velY: number
): boolean {
  const drift = Math.hypot(px - sampleX, py - sampleY);
  const vel = Math.hypot(velX, velY);
  return drift >= UNSTUCK_MOVE_EPS_PX || vel >= UNSTUCK_VEL_EPS_PX;
}

export function updateUnstuckMotion(input: UnstuckMotionInput): UnstuckMotionResult {
  if (
    input.intentMoving ||
    isPlayerMovingForUnstuck(input.px, input.py, input.sampleX, input.sampleY, input.velX, input.velY)
  ) {
    return {
      show: false,
      sampleX: input.px,
      sampleY: input.py,
      lastMovementAtMs: input.nowMs,
    };
  }
  const show =
    input.canOffer && input.nowMs - input.lastMovementAtMs >= UNSTUCK_IDLE_MS;
  return {
    show,
    sampleX: input.sampleX,
    sampleY: input.sampleY,
    lastMovementAtMs: input.lastMovementAtMs,
  };
}
